//components
import { useFormDataContext } from "../providers/form"
import DescriptionFields from "./DescriptionFields"
import ExtraDescription from "./ExtraDescription"
import SelectCategory from "./SelectCategory"
import SelectDateAndHour from "./SelectDateAndHour"
import SelectWorker from "./SelectWorker"
import TaskPayment from "./TaskPayment"
import UploadedFiles from "./UploadedFiles"

function FormTaskData({ handleValidations, viewFromHistory }) {
  const formData = useFormDataContext()

  return (
    <div className="tab task-data">
      <SelectCategory viewFromHistory={viewFromHistory} />
      <div className="row worker-data">
        <SelectWorker viewFromHistory={viewFromHistory} />
        <SelectDateAndHour
          handleValidations={handleValidations}
          viewFromHistory={viewFromHistory}
        />
      </div>
      <div className="row extra-data">
        {/* <DescriptionFields viewFromHistory={viewFromHistory} /> */}
        <div class="task-type-id-holder">
          <h6>Приоритет</h6>
          <select
            name="task_type_id"
            id="task-type-id"
            disabled={viewFromHistory}
            value={formData.getFieldForClient("taskTypeId")}
            onChange={(e) =>
              formData.setFieldsFormats("taskTypeId", e.target.value)
            }
          >
            <option value="1">Нормален</option>
            <option value="2">Спешен</option>
          </select>
          <p>Приоритетът определя звука при известие</p>
        </div>
        <ExtraDescription
          handleValidations={handleValidations}
          viewFromHistory={viewFromHistory}
        />
        <UploadedFiles viewFromHistory={viewFromHistory} />
      </div>
      <hr />
      <TaskPayment viewFromHistory={viewFromHistory} />
      {/* <ExtraDescription
        handleValidations={handleValidations}
        viewFromHistory={viewFromHistory}
      /> */}
    </div>
  )
}

export default FormTaskData
